import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { IntelligentLeadPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: IntelligentLeadPropertyConfiguration;
    update: (newConfig?: IntelligentLeadPropertyConfiguration) => void;
}

const IntelligentLeadConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="ILM Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open => {
            if (isUser)  return;
            props.update(open ? { emailDestination: '' } : undefined)}}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Email',
                            invalidText: 'Please enter an ILM Email Destination'
                        }}
                        inputProps={{
                            id: 'email-destination',
                            name: 'IntelligentLeadPropertyId',
                            value: props.config.emailDestination,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                emailDestination: value.toString()
                            })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default IntelligentLeadConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/IntelligentLeadConfigurationSection.tsx